export default "__VITE_ASSET__YP3gJxe6__"